var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormulateInput',{attrs:{"type":"select","label":_vm.label,"options":_vm.sortBy(
        _vm.category.children.map(function (cat) {
          return { label: cat.title, value: cat.id }
        }),
        function (c) { return c.label; }
      ),"input-class":"form-select","validation":"required","validation-name":_vm.label,"placeholder":"Select an option"},model:{value:(_vm.categoryID),callback:function ($$v) {_vm.categoryID=$$v},expression:"categoryID"}}),_vm._v(" "),(_vm.selectedCategory && Array.isArray(_vm.selectedCategory.children))?_c('div',[_c('clipart-category-field',{attrs:{"category":_vm.selectedCategory},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f64cc086","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ClipartCategoryField.vue
// module id = 194
// module chunks = 0